import { GridColDef } from '@mui/x-data-grid-pro';
import {
  AmountCell,
  CreatedOnCell,
  CreditDebitIcon,
  DefaultCell
} from '../../../components/OAColumn';
import { OA_DATE_TIME_FORMAT_FE } from '../../../constants';
import { GridColumnHeader } from '../../../components/OATableComponent';
import LedgerAction from '../../../components/OAColumn/LedgerAction';
import { formatNumberForCurrency, getCurrencySymbol } from '../../../helper';
import { Box } from '@mui/material';

type getLedgerColumnsType = (handleEditTransaction: (data: any) => void) => GridColDef[];

export const getLedgerColumns: getLedgerColumnsType = handleEditTransaction => {
  let draft: Array<GridColDef> = [
    {
      field: 'icon',
      renderHeader: params => <GridColumnHeader title='' params={params} />,
      renderCell: params => <CreditDebitIcon isDebited={params?.row?.debit} />,
      width: 110
    },
    {
      field: 'createdOn',
      renderHeader: params => <GridColumnHeader title='Created On' params={params} />,
      renderCell: params => (
        <CreatedOnCell date={params?.row?.createdAt} dateFormat={OA_DATE_TIME_FORMAT_FE} />
      ),
      width: 210
    },
    {
      field: 'orderId',
      renderHeader: params => <GridColumnHeader title='Order Id' params={params} />,
      renderCell: params => (params?.row?.linkedOrderId ? `#${params?.row?.linkedOrderId}` : '--'),
      width: 210
    },
    {
      field: 'Description',
      renderHeader: params => <GridColumnHeader title='Description' params={params} />,
      renderCell: params => <DefaultCell data={params?.row?.description ?? ''} />,
      width: 610
    },
    {
      field: 'debit',
      renderHeader: params => <GridColumnHeader title='Debit(INR)' params={params} />,
      renderCell: params => (
        <Box sx={{ color: '#D63939', fontWeight: 500 }}>
          {params?.row?.debit || params?.row?.debit === 0 ? `${getCurrencySymbol('INR')}${formatNumberForCurrency(params?.row?.debit)}` : 'N/A'}
        </Box>
      ),
      width: 110
    },
    {
      field: 'credit',
      renderHeader: params => <GridColumnHeader title='Credit(INR)' params={params} />,
      renderCell: params => (
        <Box sx={{ color: '#2FB344', fontWeight: 500 }}>
          {params?.row?.credit || params?.row?.credit === 0 ? `${getCurrencySymbol('INR')}${formatNumberForCurrency(params?.row?.credit)}` : 'N/A'}
        </Box>
      ),
      width: 110
    },
    {
      field: 'balance',
      renderHeader: params => <GridColumnHeader title='Balance(INR)' params={params} />,
      renderCell: params => (
        <Box sx={{ fontWeight: 500 }}>
          {params?.row?.runningBalance || params?.row?.runningBalance === 0
            ? `${getCurrencySymbol('INR')}${formatNumberForCurrency(params?.row?.runningBalance)}`
            : 'N/A'}
        </Box>
      ),
      width: 110
    },
    {
      field: 'edit',
      renderHeader: params => <GridColumnHeader title='' params={params} />,
      renderCell: params => (
        <LedgerAction data={params?.row} handleEditTransaction={handleEditTransaction} />
      ),
      width: 110
    }
  ];
  return draft;
};

export const verticalLedgerColumns: getLedgerColumnsType = handleEditTransaction => {
  let draft: Array<GridColDef> = [
    {
      field: 'entryId',
      renderHeader: params => <GridColumnHeader title='Entry Id' params={params} />,
      renderCell: params => <DefaultCell data={params?.row?.entryId ?? ''} />,
      width: 310
    },
    {
      field: 'entityType',
      renderHeader: params => <GridColumnHeader title='type' params={params} />,
      renderCell: params => <DefaultCell data={params?.row?.entryType ?? ''} />,
      width: 110
    },
    {
      field: 'Vertical',
      renderHeader: params => <GridColumnHeader title='Vertical' params={params} />,
      renderCell: params => <DefaultCell data={params?.row?.vertical ?? ''} />,
      width: 110
    },
    {
      field: 'BookingId',
      renderHeader: params => <GridColumnHeader title='Booking Id' params={params} />,
      renderCell: params => <DefaultCell data={params?.row?.bookingId ?? ''} />,
      width: 310
    },
    {
      field: 'Amount',
      renderHeader: params => <GridColumnHeader title='Amount(INR)' params={params} />,
      renderCell: params => <AmountCell data={params?.row?.amount ?? 0} />,
      width: 160
    },
    {
      field: 'balance',
      renderHeader: params => <GridColumnHeader title='Balance(INR)' params={params} />,
      renderCell: params => (
        <Box sx={{ fontWeight: 500 }}>
          {params?.row?.balanceAfter || params?.row?.balanceAfter === 0
            ? `${getCurrencySymbol('INR')}${formatNumberForCurrency(params?.row?.balanceAfter)}`
            : 'N/A'}
        </Box>
      ),
      width: 210
    },
    {
      field: 'Date',
      renderHeader: params => <GridColumnHeader title='Date' params={params} />,
      renderCell: params => (
        <CreatedOnCell date={params?.row?.createdAt} dateFormat={OA_DATE_TIME_FORMAT_FE} />
      ),
      width: 210
    },
  ];
  return draft;
};